import React from 'react'
import PropTypes from 'prop-types'

const withTooltip = Component => {
  class TooltipWrapper extends React.Component {
    componentDidMount () {
      window.$(this.node).tooltip({
        title: this.props.tooltipTitle
      })
    }

    render () {
      return (
        <div ref={node => (this.node = node)}>
          <Component {...this.props} />
        </div>
      )
    }
  }

  TooltipWrapper.propTypes = {
    tooltipTitle: PropTypes.string
  }

  return TooltipWrapper
}

export default withTooltip



// WEBPACK FOOTER //
// ./src/components/form/with-tooltip/index.js